import { FormBlock, FormButtons, FormManager, FormRow, Initializer, useCloneEntity } from 'gossamer-front-end';
import { FieldType, OptionsField } from 'gossamer-unified';
import { Modal } from 'react-bootstrap';
import { Group, TimetableSession, TimetableSessionRow } from 'timetable-model';

interface SessionModalProps {
  groups: Group[];
  isCreate: boolean;
  session: TimetableSessionRow;
  onCancel: () => void;
  onSave: (updatedSession: Partial<TimetableSessionRow>) => void;
}

export const SessionModal = (props: SessionModalProps): React.JSX.Element => {
  const { session, onCancel, onSave } = props;
  const LocalTimesheetSession = useCloneEntity(TimetableSession, (local) => {
    local.fields.id.visible = false;
    local.fields.timetable_id.visible = false;
    local.fields.created_at.visible = false;
    local.fields.updated_at.visible = false;
    local.fields.group_id.type = FieldType.Options;
    (local.fields.group_id as OptionsField).options = props.groups.map((g) => ({ label: g.name, id: String(g.id) }));
  });
  const initializer: Initializer<TimetableSessionRow> = props.isCreate
    ? {
        entity: LocalTimesheetSession,
        type: 'create-single',
        override: session,
      }
    : {
        entity: LocalTimesheetSession,
        type: 'update-single',
        record: { data: session, error: undefined, isFetching: false },
      };
  return (
    <FormManager
      handleSuccess={(resp, _resetCache, values) => {
        const newSession = Object.assign({}, values.main) as FormRow<TimetableSessionRow>;
        newSession.group_id = Number(newSession.group_id);
        if (resp.keyOfFirstCreate) {
          newSession.id = Number(resp.keyOfFirstCreate);
        }
        onSave(newSession);
      }}
      compoundUrl="/main/~/timetable-session-upsert"
      initialization={{ main: initializer }}
      render={({ handleSubmit, isSubmitting, setFieldValue }) => {
        return (
          <Modal show={true} onHide={onCancel}>
            <Modal.Header closeButton>
              <Modal.Title>{props.isCreate ? 'New Session' : session.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormBlock alias="main" entity={LocalTimesheetSession} isCreate={props.isCreate} layout="vertical" />
            </Modal.Body>
            <Modal.Footer>
              <FormButtons
                handleCancel={onCancel}
                handleSubmit={(outcomeId: string) => {
                  // debug(`submitting`, outcomeId);
                  setFieldValue('_outcome', outcomeId);
                  handleSubmit();
                }}
                submitting={isSubmitting}
              />
            </Modal.Footer>
          </Modal>
        );
      }}
    ></FormManager>
  );
};
